import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { languageService } from "./lang/Lang.js";

// English is bundled as the guaranteed fallback; the other languages are
// loaded on demand so the legal texts stay out of the main chunk.
import privacyDefaultEn from './legal/privacy-default-en.json';
import privacyUaeEn from './legal/privacy-uae-en.json';

const API_URL = process.env.REACT_APP_API_URL || 'https://ar.sahra.ai/api';

const PRIVACY_EN = { default: privacyDefaultEn, uae: privacyUaeEn };

// Languages with a translated Privacy Policy in ./legal (see the language selector in Links.js)
const TRANSLATED = ['ar', 'de', 'es', 'fr', 'it', 'bg', 'sr'];

export default function Privacy() {
  const [privacyContent, setPrivacyContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPrivacy = async () => {
      try {
        // Get user language ('ar-AE' and the like resolve to 'ar')
        const lang = (languageService.getLanguage() || 'en').toLowerCase().split('-')[0];

        // Check for URL parameter override (for testing)
        const urlParams = new URLSearchParams(window.location.search);
        const countryOverride = urlParams.get('country');

        // Fetch country from geo endpoint
        let country = 'XX';
        if (countryOverride) {
          // Use URL override if provided
          country = countryOverride.toUpperCase();
        } else {
          try {
            const response = await fetch(`${API_URL}/geo`);
            const data = await response.json();
            country = data.country || 'XX';
          } catch (geoError) {
            console.warn('Geo lookup failed, using default privacy:', geoError);
          }
        }

        // UAE jurisdiction for the Emirates, Spain jurisdiction everywhere else
        const jurisdiction = country === 'AE' ? 'uae' : 'default';

        let privacy = PRIVACY_EN[jurisdiction];
        if (TRANSLATED.indexOf(lang) !== -1) {
          try {
            const translated = await import(`./legal/privacy-${jurisdiction}-${lang}.json`);
            privacy = translated.default || translated;
          } catch (importError) {
            console.warn(`Privacy translation "${lang}" failed to load, using English:`, importError);
          }
        }

        setPrivacyContent(privacy.privacy);
      } catch (error) {
        console.error('Error loading privacy:', error);
        // Fallback to default English privacy
        setPrivacyContent(privacyDefaultEn.privacy);
      } finally {
        setLoading(false);
      }
    };

    loadPrivacy();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '60px 20px', textAlign: 'center' }}>
        Loading...
      </div>
    );
  }

  return <div>{ReactHtmlParser(privacyContent)}</div>;
}
